import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceTagForm from '../containers/ResourceTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceTagAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceTagAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_tag_route_add')} />
          <ResourceTagForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceTagAddScreen;

Logger.log('silly', `ResourceTagAddScreen loaded.`);
